module.exports = __webpack_public_path__ + "img/Inside-sp_8.82036417.jpg";